export default __webpack_public_path__ + "static/media/no-del-contracts.aa871c20.svg";